/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { API } from '@src/api';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { memberInContextAtom } from '@src/global-state';
import { useAtom } from 'jotai';
import {
  Breadcumbs,
  ScreenConstants,
} from '@src/common/BreadCumbs/Breadcrumbs';

export const AssessmentHeader = () => {
  const [memberInContext, setMemberInContext] = useAtom(memberInContextAtom);
  let apiResponse;
  //  const [data1, setData1] = useState();

  const [id] = useState(memberInContext?.member_id);
  const [showDefault, setDefualt] = useState<boolean>(false);
  // eslint-disable-next-line prefer-const
  let [memberInfo, setMemberInfo] = useState({
    id: '',
    memberLastName: '',
    memberFirstName: '',
    email: '',
    phone: '',
    DOB: '',
    zipcode: '',
    lob: '',
    createdDate: '',
  });

  const ColoredBoxContainer = styled('div', {
    '@screen >= $md': {
      paddingLeft: '3.5%',
      paddingRight: '5.5%',
      paddingTop: '1%',
      paddingBottom: '1%',
    },
    '@screen < $md': {
      textAlign: 'center',
      padding: '0px',
    },
  });
  useEffect(() => {
    const fetchMemberScreeningHistory = async () => {
      try {
        apiResponse = await API.getMemberScreeningHistory(
          memberInContext?.member_id
        );
        if (apiResponse.data !== null && apiResponse.data !== undefined) {
          setMemberInfo(apiResponse.data);
        } else setDefualt(true);
      } catch (err) {}
    };

    fetchMemberScreeningHistory();
  }, [id]);

  return (
    <React.Fragment>
      <ColoredBoxContainer>
        <Breadcumbs screen={ScreenConstants.SDOH_SCREENER} />
        <Grid>
          <Grid.Col span={{ xs: '100%', md: '60%', lg: '100%' }}>
            <br />
            <span onClick={() => {}} style={{ color: '#002677', fontWeight: 'bold' }}>
              {memberInContext?.first_name}{' '}
              {memberInContext?.last_name
                .split(/(?<=\s|-)/)
                .map((word) => {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join('')}
              {showDefault ? (
                <div>Member has never been screened on Community Connector</div>
              ) : (
                <div>
                  Last screened on Community Connector :&nbsp;
                  {dayjs(memberInfo?.createdDate).format('MMM D, YYYY')}
                </div>
              )}
            </span>

            <Heading serif>Screen {memberInContext?.first_name}'s needs</Heading>
          </Grid.Col>
        </Grid>
      </ColoredBoxContainer>
    </React.Fragment>
  );
};
